import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
import { DateRange, DEFAULT_DATE_RANGE } from "../components";
import { storageWithDateRange } from "../utils";

type Inputs = {
  dateRange: DateRange;
};

type HomeTabInputsState = Inputs & {
  upsert: (inputs: Partial<Inputs>) => void;
};

export const useHomeTabInputs = create<HomeTabInputsState>()(
  devtools(
    persist(
      (set) => ({
        dateRange: DEFAULT_DATE_RANGE,
        upsert: (inputs) => set((state) => ({ ...state, ...inputs })),
      }),
      {
        name: "home-tab-inputs",
        storage: storageWithDateRange,
      },
    ),
  ),
);
